import { Button, Group, Modal, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const TodoNotFoundModal = ({
    opened,
    onClose,
    todoTitle,
}: {
    todoTitle: string;
    opened: boolean;
    onClose: () => void;
}) => {
    const { t } = useTranslation('todo');
    return (
        <Modal centered opened={opened} onClose={onClose} title={t('component.todoDrawer.not_found_modal.title')}>
            <Text lineClamp={2} c="dimmed">
                {todoTitle
                    ? t('component.todoDrawer.not_found_modal.message_with_title', { title: todoTitle })
                    : t('component.todoDrawer.not_found_modal.message')}
            </Text>
            <Group justify="flex-end" mt="lg">
                <Button onClick={onClose}>{t('component.todoDrawer.not_found_modal.confirm')}</Button>
            </Group>
        </Modal>
    );
};
